export function toLocaleDateTimeString(date: string): string {
  return new Date(date).toLocaleString();
}

export function toLocaleDateString(date: string): string {
  return date === null ? '' : new Date(date).toLocaleDateString();
}

export function formatTimeSpan(timeSpan: string): string {
  return timeSpan.includes('.') ? timeSpan.substring(0, timeSpan.lastIndexOf('.')) : timeSpan;
}

export function getCurrentUTCTime(): Date {
  const now = new Date();
  now.setMinutes(now.getMinutes() + now.getTimezoneOffset());

  return now;
}

export function dateToUTC(date: Date): Date {
  const utcDate = new Date(date);
  utcDate.setMinutes(utcDate.getMinutes() + utcDate.getTimezoneOffset());

  return utcDate;
}

export function formatSecondsToTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const formattedHours = hours.toString();
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

export function getMonth(date: Date): string {
  return date.toLocaleString('default', { month: 'long' });
}
